import script from "./GreenAPIChatFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./GreenAPIChatFrame.vue?vue&type=script&setup=true&lang=js"

import "./GreenAPIChatFrame.vue?vue&type=style&index=0&id=7b646d10&lang=css"

const __exports__ = script;

export default __exports__